import { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  es: {
    "nav.home": "Inicio",
    "nav.services": "Servicios",
    "nav.gallery": "Galería",
    "nav.team": "Equipo",
    "nav.reviews": "Opiniones",
    "nav.hours": "Horario",
    "nav.book": "Agendar cita",
    "nav.call": "Llamar",
    "hero.eyebrow": "BARBERÍA PROFESIONAL — HURST, TX",
    "hero.sub": "Corte clásico y moderno, barba y afeitado tradicional. Un espacio hecho para el caballero.",
    "hero.cta_whatsapp": "Agendar por WhatsApp",
    "hero.cta_book": "Ver servicios",
    "hero.walkins": "Walk-ins bienvenidos",
    "hero.scroll": "Desliza",
    "services.eyebrow": "NUESTROS SERVICIOS",
    "services.title": "El oficio, a detalle",
    "services.sub": "Cada servicio se realiza con productos de calidad y la precisión que caracteriza a Blackbeard.",
    "services.book": "Reservar",
    "gallery.eyebrow": "GALERÍA",
    "gallery.title": "Nuestro trabajo",
    "gallery.all": "Todos",
    "gallery.cortes": "Cortes",
    "gallery.barbas": "Barbas",
    "gallery.estilo": "Estilo",
    "gallery.empty": "Pronto publicaremos más trabajos.",
    "gallery.before": "Antes",
    "gallery.after": "Después",
    "team.eyebrow": "EQUIPO",
    "team.title": "Barberos",
    "team.book_with": "Agendar",
    "team.empty": "Equipo en camino.",
    "video.eyebrow": "VIDEO PROMOCIONAL",
    "video.title": "Vive la experiencia",
    "reviews.eyebrow": "TESTIMONIOS",
    "reviews.title": "Lo que dicen nuestros clientes",
    "reviews.empty": "Aún no hay opiniones.",
    "reviews.google_count": "{n} reseñas en Google",
    "reviews.google_cta": "Reseñas en Google",
    "hours.eyebrow": "HORARIO Y UBICACIÓN",
    "hours.title": "Visítanos",
    "hours.open_now": "Abierto ahora",
    "hours.closed_now": "Cerrado ahora",
    "hours.address_label": "Dirección",
    "hours.maps_cta": "Ver en Google Maps",
    "form.eyebrow": "RESERVA TU CITA",
    "form.title": "Agenda tu estilo",
    "form.sub": "Déjanos tus datos y confirma por WhatsApp. También aceptamos walk-ins.",
    "form.name": "Nombre",
    "form.phone": "Teléfono",
    "form.service": "Servicio",
    "form.service_any": "Cualquier servicio",
    "form.date": "Fecha",
    "form.time": "Hora",
    "form.notes": "Notas",
    "form.notes_ph": "Cuéntanos qué estilo buscas…",
    "form.submit": "Enviar solicitud",
    "form.sending": "Enviando…",
    "form.success": "¡Solicitud enviada! Te esperamos.",
    "form.error": "No se pudo enviar. Revisa los datos e intenta de nuevo.",
    "form.wa_confirm": "Confirmar por WhatsApp",
    "footer.rights": "Todos los derechos reservados.",
    "footer.admin_link": "Panel de administración",
    "common.copyright_name": "BLACKBEARD BARBERÍA",
  },
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.gallery": "Gallery",
    "nav.team": "Team",
    "nav.reviews": "Reviews",
    "nav.hours": "Hours",
    "nav.book": "Book now",
    "nav.call": "Call",
    "hero.eyebrow": "PROFESSIONAL BARBERSHOP — HURST, TX",
    "hero.sub": "Classic and modern cuts, beard work and traditional shaves. A space made for the modern gentleman.",
    "hero.cta_whatsapp": "Book via WhatsApp",
    "hero.cta_book": "View services",
    "hero.walkins": "Walk-ins welcome",
    "hero.scroll": "Scroll",
    "services.eyebrow": "OUR SERVICES",
    "services.title": "The craft, in detail",
    "services.sub": "Every service is done with quality products and the precision that defines Blackbeard.",
    "services.book": "Book",
    "gallery.eyebrow": "GALLERY",
    "gallery.title": "Our work",
    "gallery.all": "All",
    "gallery.cortes": "Cuts",
    "gallery.barbas": "Beards",
    "gallery.estilo": "Style",
    "gallery.empty": "More work coming soon.",
    "gallery.before": "Before",
    "gallery.after": "After",
    "team.eyebrow": "TEAM",
    "team.title": "Barbers",
    "team.book_with": "Book",
    "team.empty": "Team coming soon.",
    "video.eyebrow": "PROMO VIDEO",
    "video.title": "Live the experience",
    "reviews.eyebrow": "TESTIMONIALS",
    "reviews.title": "What our clients say",
    "reviews.empty": "No reviews yet.",
    "reviews.google_count": "{n} Google reviews",
    "reviews.google_cta": "Reviews on Google",
    "hours.eyebrow": "HOURS & LOCATION",
    "hours.title": "Visit us",
    "hours.open_now": "Open now",
    "hours.closed_now": "Closed now",
    "hours.address_label": "Address",
    "hours.maps_cta": "View on Google Maps",
    "form.eyebrow": "BOOK YOUR APPOINTMENT",
    "form.title": "Book your style",
    "form.sub": "Leave your details and confirm via WhatsApp. Walk-ins also welcome.",
    "form.name": "Name",
    "form.phone": "Phone",
    "form.service": "Service",
    "form.service_any": "Any service",
    "form.date": "Date",
    "form.time": "Time",
    "form.notes": "Notes",
    "form.notes_ph": "Tell us the style you're after…",
    "form.submit": "Send request",
    "form.sending": "Sending…",
    "form.success": "Request sent! See you soon.",
    "form.error": "Couldn't send. Check your details and try again.",
    "form.wa_confirm": "Confirm via WhatsApp",
    "footer.rights": "All rights reserved.",
    "footer.admin_link": "Admin panel",
    "common.copyright_name": "BLACKBEARD BARBERÍA",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("bb-lang") || "es");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("bb-lang", l);
  };

  const toggle = () => setLang(lang === "es" ? "en" : "es");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const get = (d, key) => (d || {})[key];
  const t = (key) => get(DICT[lang], key) ?? get(DICT.es, key) ?? key;
  const L = (es, en) => (lang === "es" ? es : en);

  return <LanguageContext.Provider value={{ lang, setLang, toggle, t, L }}>{children}</LanguageContext.Provider>;
}

export const useI18n = () => useContext(LanguageContext);
